<template>
    <div>
        <HeaderMenu></HeaderMenu>
    </div>
</template>
<script>
import axios from 'axios'
import HeaderMenu from '../HeaderMenu'
import Slick from 'vue-slick';
import 'slick-carousel/slick/slick.css';

export default{
    data(){
        this.get_health_courses();
        this.get_nmtc_courses()
        return {
            health_courses:null,
            nmtc_courses:null,
            hostname:this.$hostname,
            current_locale:this.$i18n_global.locale,
            slickOptions: {
                slidesToShow: 3,
                infinite: false,
                slidesToScroll: 1,
                dots: true,
                arrows: true,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            },
        }
    },
    components:{
        HeaderMenu:HeaderMenu,
        Slick:Slick
    },
    methods:{
        async get_health_courses() {
            var _self = this; 
            await this.$axios_global.post(_self.$hostname+'/api/courses-by-category',{
                cat:'healthcare-quality'
            })
            .then((res) => {
                var response = res.data.data;
                _self.health_courses = response;
            })
            .catch((error) => {
                return false;  
            }) 
            return false; 
        },
        async get_nmtc_courses() {
            var _self = this; 
            await this.$axios_global.post(_self.$hostname+'/api/courses-by-category',{
                cat:'medical-education-clinical-reasearch'
            })
            .then((res) => {
                var response = res.data.data;
                _self.nmtc_courses = response;
            })
            .catch((error) => {
                return false;  
            }) 
            return false; 
        },
        format_date(value){
            if (value) {
               return this.$moment_global(String(value)).format('MMM YYYY')
            }
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Pages/WhatWeDo.vue